/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateImportedIndicatorTestDto
 */
export interface CreateUpdateImportedIndicatorTestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateImportedIndicatorTestDto
     */
    testIdentifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateImportedIndicatorTestDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateImportedIndicatorTestDto
     */
    mode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateImportedIndicatorTestDto
     */
    keyTestName?: string | null;
}

/**
 * Check if a given object implements the CreateUpdateImportedIndicatorTestDto interface.
 */
export function instanceOfCreateUpdateImportedIndicatorTestDto(value: object): value is CreateUpdateImportedIndicatorTestDto {
    return true;
}

export function CreateUpdateImportedIndicatorTestDtoFromJSON(json: any): CreateUpdateImportedIndicatorTestDto {
    return CreateUpdateImportedIndicatorTestDtoFromJSONTyped(json, false);
}

export function CreateUpdateImportedIndicatorTestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateImportedIndicatorTestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'testIdentifier': json['testIdentifier'] == null ? undefined : json['testIdentifier'],
        'name': json['name'] == null ? undefined : json['name'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'keyTestName': json['keyTestName'] == null ? undefined : json['keyTestName'],
    };
}

export function CreateUpdateImportedIndicatorTestDtoToJSON(value?: CreateUpdateImportedIndicatorTestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'testIdentifier': value['testIdentifier'],
        'name': value['name'],
        'mode': value['mode'],
        'keyTestName': value['keyTestName'],
    };
}

